import { FC, PropsWithChildren, useRef } from "react";
import { ModalOverlayProps } from "react-aria-components";
import { IconDialogClose } from "../../../icons/IconDialogClose"; // Don't change this. `icons` folder is outside `src` -> results in a type check error without the dots
import { CustomDialogCloseButton } from "./CustomDialogCloseButton";
import { CustomDialogStyled } from "./CustomDialog.styled";

const { StyledModalOverlay, StyledModal, StyledDialog } = CustomDialogStyled;

type CustomDialogProps = ModalOverlayProps &
  PropsWithChildren<{
    animated?: boolean;
  }>;

export const CustomDialog: FC<CustomDialogProps> = ({
  children,
  animated = true,
  ...props
}) => {
  const overlayRef = useRef(null);

  return (
    <StyledModalOverlay ref={overlayRef} animated={animated}>
      <StyledModal {...props} animated={animated}>
        <StyledDialog>
          <CustomDialogCloseButton slot={"close"}>
            <IconDialogClose />
          </CustomDialogCloseButton>
          {children}
        </StyledDialog>
      </StyledModal>
    </StyledModalOverlay>
  );
};
